/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventSceneManagementEndEventResponse } from './EventSceneManagementEndEventResponse';

export type EventSceneManagementEndEventResponseApiRespoonse = {
    data?: EventSceneManagementEndEventResponse;
    status?: EventSceneManagementEndEventResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventSceneManagementEndEventResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

